import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    "MapComponent": () => import("./components/MapComponent.vue"),
    "MapPreviewComponent": () => import("./components/MapPreviewComponent.vue"),
    "MapLegend": () => import("./components/MapLegend.vue"),
    "GeocodingSearch": () => import("./components/controls/GeocodingSearch.vue"),
    "GeocodingTileButton": () => import("./components/controls/GeocodingTileButton.vue"),
    "LayerIcon": () => import("./components/common/LayerIcon.vue"),

    "LegendToolbar": () => import("./components/common/legend/LegendToolbar.vue"),
    "LayerMetadata": () => import("./components/common/legend/LayerMetadata.vue"),
    "ThemeConfiguratorContainer": () => import("./components/common/legend/theme/ThemeConfiguratorContainer.vue"),

};
export default globals;
